import { CardIdentifier } from '../../../../types';
import { TransactionType } from './types';

export class CardTransaction {
  valueDate: string;
  postingDate: string;
  merchantName: string;
  status: string;
  transactionId: string;
  grossAmount: {
    value: number;
    currency: string;
  };
  principalAmount: {
    value: number;
    currency: string;
  };
  rrn: string;
  country: string;
  debitCreditDirection: TransactionType;
  transactionIdentifications: {
    transactionIdentificationType: string;
    identifier: CardIdentifier;
  }[];

  constructor(
    valueDate: string,
    postingDate: string,
    merchantName: string,
    status: string,
    transactionId: string,
    grossAmount: {
      value: number;
      currency: string;
    },
    principalAmount: {
      value: number;
      currency: string;
    },
    rrn: string,
    country: string,
    debitCreditDirection: TransactionType,
    transactionIdentifications: {
      transactionIdentificationType: string;
      identifier: CardIdentifier;
    }[],
  ) {
    this.valueDate = valueDate;
    this.postingDate = postingDate;
    this.merchantName = merchantName;
    this.status = status;
    this.transactionId = transactionId;
    this.grossAmount = grossAmount;
    this.principalAmount = principalAmount;
    this.rrn = rrn;
    this.country = country;
    this.debitCreditDirection = debitCreditDirection;
    this.transactionIdentifications = transactionIdentifications;
  }
}
